import ComboboxInput from '../Reusable/Form/ComboboxInput';
import APIS from '../../constant/EndPoint';
import TextField from '../Reusable/Form/TextInput';

const OrderForm = ({ errors, register, setValue, getValues, clearErrors, setOpenAddSenderPopup,
  openAddSenderPopup,
  setOpenAddReceiverPopup,
  openAddReceiverPopup, fields, remove, append, profile }: any) => {
  return (
    <>
      <div className="w-full mt-6 flex justify-between px-4 gap-x-2 uppercase font-extrabold items-center">
        <div className="text-[#5E5757] font-bold text-sm">
          Vendor Informations
        </div>
      </div>
      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-x-4 px-4">
        <>
          <ComboboxInput
            url={APIS.MERCHANT}
            queryKey={"merchant"}
            register={register("vendor")}
            errors={errors?.vendor}
            name={"vendor"}
            label={"Vendor/Merchant"}
            setValue={setValue}
            placeholder={"Search Vendor/Merchant"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
          <ComboboxInput
            url={APIS.BRANCH}
            queryKey={"barnch"}
            register={register("pickup_branch", {
              required: "Pickup branch is required",
            })}
            errors={errors?.pickup_branch}
            name={"pickup_branch"}
            label={"From"}
            props={{ is_active: true }}
            setValue={setValue}
            getValues={getValues}
            placeholder={"Search Pickup Branch"}
            clearErrors={clearErrors}
            disabled={!profile?.is_superuser}
          />

        </>
      </div>
      <div className="grid grid-cols-2">
        <div>
          <div className="w-full mt-6 flex justify-left px-4 gap-x-2 uppercase font-extrabold items-center">
            <span className="text-[#5E5757] font-bold text-sm">
              Sender Informations
            </span>
          </div>
          <div className="w-full flex justify-center items-center px-4">
            <div className="w-full">
              <ComboboxInput
                url={APIS.CUSTOMER}
                queryKey={"customer"}
                register={register('sender')}
                errors={errors?.sender}
                name={`sender`}
                setValue={setValue}
                placeholder={"Search Sender"}
                getValues={getValues}
                clearErrors={clearErrors}
              />
            </div>
            <button className="border px-4 p-2 mt-3 " type='button' onClick={() => setOpenAddSenderPopup(!openAddSenderPopup)}>+</button>
          </div>
        </div>
        <div>
          <div className="w-full mt-6 flex justify-left px-4 gap-x-2 uppercase font-extrabold items-center">
            <span className="text-[#5E5757] font-bold text-sm">
              Receiver Informations
            </span>
          </div>
          <div className="w-full flex justify-center items-center px-4">
            <div className="w-full">
              <ComboboxInput
                url={APIS.CUSTOMER}
                queryKey={"customer"}
                register={register('customer')}
                errors={errors?.receiver}
                name={`receiver`}
                setValue={setValue}
                placeholder={"Search Receiver"}
                getValues={getValues}
                clearErrors={clearErrors}
              />
            </div>
            <button className="border px-4 p-2 mt-3 " type='button' onClick={() => setOpenAddReceiverPopup(!openAddReceiverPopup)}>+</button>
          </div>
        </div>
      </div>
      <div className="w-full mt-6 flex justify-between px-4 gap-x-2 uppercase font-extrabold items-center">
        <div className="text-[#5E5757] font-bold text-sm">
          Shipment Informations
        </div>

      </div>
      <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-x-2 px-4">
        <ComboboxInput
          url={APIS.LOCATION}
          props={{ level: 3, is_active: true }}
          queryKey={"location"}
          register={register(
            `destination` as const,
            {
              required: "Destination city is required",
            }
          )}
          errors={errors?.destination}
          name={"destination"}
          label={"Destination"}
          setValue={setValue}
          getValues={getValues}
          placeholder={"Search Destination City"}
          clearErrors={clearErrors}
        />
        <ComboboxInput
          url={APIS.PRODUCT_TYPE}
          queryKey={"product-type"}
          register={register(`product_type` as const, {
            required: "Product Type is required",
          })}
          errors={errors?.service_type}
          name={`product_type`}
          label={"Product Type"}
          setValue={setValue}
          placeholder={"Search Product Type"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <TextField
          label={"Reference"}
          placeholder="Reference"
          register={register(`reference_number` as const, {
            required: false,
          })}
          errors={errors?.note}
        />
      </div>
      <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-x-2 px-4">
        <TextField
          label={"Weight"}
          placeholder="Weight"
          register={register(`weight` as const, {
            required: false,
          })}
          errors={errors?.note}
        />
        <TextField
          label={"COD"}
          placeholder="COD"
          register={register(`cod` as const, {
            required: false,
          })}
          errors={errors?.note}
        />
        <TextField
          label={"Delivery Charge"}
          placeholder="Delivery Charge"
          register={register(`delivery_charge` as const, {
            required: false,
          })}
          errors={errors?.note}
        />

        <TextField
          label={"Remarks"}
          placeholder="Remarks"
          register={register(`note` as const, {
            required: false,
          })}
          errors={errors?.note}
        />
      </div>
      <hr className="mt-6" />
    </>
  )
}

export default OrderForm